function IfPage(controller, action, callback) {
    var contentInner = document.getElementById('content-inner')
    if (contentInner == null) return;
    if (!contentInner.classList.contains(`controller-${controller}`)) return;
    if (!contentInner.classList.contains(`action-${action}`)) return;

    callback(contentInner);
}

export default IfPage
